import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
  Paper,
  Radio,
  Typography,
} from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import { receiptPurposeList } from "assets/properties/properties";
import { repaymentTypeTypeList } from "assets/properties/properties";
import { professionTypeList } from "assets/properties/properties";
import { residanceTypeList } from "assets/properties/properties";
import ToastModal from "views/components/ToastModal";
import { receiptPurposeTypeList } from "assets/properties/properties";
import { parseDateTime } from "utils/Utils";
import { repaymentTypeList } from "assets/properties/properties";
import { generateRandomNumber } from "utils/Utils";
import { saveUserCurrentPaymentDetails } from "store/reducers/login/LoginSlice";
import { QRCodeSVG } from "qrcode.react";
import { formatAmount } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "92%",
    margin: "10px auto",
    minHeight: "85vh",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  summaryCard: {
    borderRadius: 15,
    border: "1px solid #E8E8E8",
    padding: 25,
    height: "100%",
    background: "#fff",
  },

  paymentCard: {
    borderRadius: 15,
    border: "1px solid #E8E8E8",
    padding: 25,
    height: "100%",
    background: "#fff",
  },

  cardTitle: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 20,
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 0",
    borderBottom: "1px solid #F2F2F2",
  },

  summaryLabel: {
    color: "#666",
    fontWeight: 500,
  },

  summaryValue: {
    fontWeight: 600,
  },

  paymentOption: {
    border: "1px solid #E4E4E4",
    borderRadius: 10,
    padding: "10px 15px",
    marginBottom: 15,
    cursor: "pointer",
  },

  amountBox: {
    background: "#F7F8FA",
    borderRadius: 10,
    padding: 20,
    textAlign: "center",
    marginTop: 20,
    marginBottom: 20,
  },

  payAmount: {
    fontSize: 36,
    fontWeight: 700,
    color: "#17A34A",
  },

  proceedButton: {
    height: 50,
    borderRadius: 8,
    background: "#17A34A",
    color: "#fff",
    fontWeight: 600,

    "&:hover": {
      background: "#14853d",
    },
  },

  qrWrapper: {
    marginTop: 30,
    textAlign: "center",
  },

  qrImage: {
    width: 220,
    maxWidth: "100%",
  },

  footerText: {
    marginTop: 20,
    color: "#666",
    textAlign: "center",
    fontSize: 13,
  },
}));

const PayNow = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loanNumber = location.state?.loanNumber;
  const { mobileNumber, name, email } = useSelector(
    (state) => state.login.userData
  );
  // const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const [receiptPurpose, setReceiptPurpose] = useState("");
  const [repaymentType, setRepaymentType] = useState("");
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [disaledFields, setDisabledFields] = useState(false);
  const [provider, setProvider] = useState([]);
  const [activeTab, setActiveTab] = useState("UPI");
  const [qrData, setQrData] = useState(null);
  const [collateralData, setCollateralData] = useState({});
  const [customerLoanData, setCustomerLoanData] = useState({});
  const [outStandingLoanData, setOutStandingLoanData] = useState({});
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(mobileNumber, name, email, "adjfbajdf");
  useEffect(()=>{
    getProviderNames();
    collateralDetails();
  },[])
  const collateralDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_PROVEDIER_DETAILS + loanNumber,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_descrition, true);
    } else {
      await customerLoanDetails(result?.data);
    }
  };
  const customerLoanDetails = async (collateralDetails) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_CUSTOMER_LOAN_DETAILS + loanNumber,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_descrition, true);
    } else {
      await loanOutstanding(collateralDetails, result?.data)
    }
  };
  const loanOutstanding = async (collateralDetails, custDetails) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FIND_LOAN_OUTSTANDING + loanNumber,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_descrition, true);
    } else {
      setCollateralData(collateralDetails);
      setCustomerLoanData(custDetails);
      setOutStandingLoanData(result?.data);   
    }
  };
  const getProviderNames = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_PROVEDIER_DETAILS,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_descrition, true);
    } else {
      setProvider(result?.data);
    }
  };
  const initiatePayment = async (selectedProvider) => {
    try {
      setCallInProgress(true);

      const payload = {
        loanAccountNumber: loanNumber,
        amount,
        remarks,
        tokenRequired: selectedProvider === "AU_UPI" ? true : false,
        furl: window.location.origin + "/PaymentFailed",
        surl: window.location.origin + "/PaymentSuccess",
      };

      if (selectedProvider === "AU_UPI") {
        payload.tokenRequired = true;
      }

      const result = await apiHandler({
        url: endpoint.USESR_INITIATE_PAYMENT_API,
        method: "POST",
        authToken,
        data: payload,
      });

      setCallInProgress(false);

      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
        return;
      }

      if (selectedProvider === "AU_UPI") {
        dispatch(
          saveUserCurrentPaymentDetails({
            transactionId: result?.data?.orderId,
            amount: amount,
            date: new Date(),
          })
        );
        const token = result?.data?.token || result?.data?.paymentToken;

        if (token) {
          window.location.href = `https://pay.easebuzz.in/pay/${token}`;
        }
        return;
      }

      setQrData(result?.data);
    } catch (error) {
      setCallInProgress(false);

      toastUpdate("Error", error?.message, true);
    }
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
       <SubHeader
          label="Pay Now"
          button1="Cancel"
          button1click={() => navigate("/Repayment")}
          noButton
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Amount"
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
              type="number"
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Receipt Purpose"
              value={receiptPurpose}
              onChange={(e) => setReceiptPurpose(e.target.value)}
              options={receiptPurposeTypeList}
              style={classes.documentSelectBox}
              disabled={disaledFields}
            />
          </Grid>
          {receiptPurpose === "PART_PREPAYMENT" && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomSelect
                label="Part Payment Impact"
                value={repaymentType}
                onChange={(e) => setRepaymentType(e.target.value)}
                options={repaymentTypeList}
                style={classes.documentSelectBox}
                disabled={disaledFields}
              />
            </Grid>
          )} */}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Remarks"
              placeholder="Remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3} style={{ margin: '10px auto 50px' }}>
        <Grid item xs={12} md={6}>
          <Paper className={classes.summaryCard}>
            <Typography className={classes.cardTitle}>
              Payment Summary
            </Typography>
            <Box className={classes.summaryRow}>
              <Typography className={classes.summaryLabel}>
                Loan Account No.
              </Typography>
              <Typography className={classes.summaryValue}>
                {loanNumber}
              </Typography>
            </Box>
            <Box className={classes.summaryRow}>
              <Typography className={classes.summaryLabel}>
                Avalied on
              </Typography>
              <Typography className={classes.summaryValue}>
                {parseDateMDY(customerLoanData?.availedOn)}
              </Typography>
            </Box>
              <Box className={classes.summaryRow}>
                <Typography className={classes.summaryLabel}>
                  Loan Expires at
                </Typography>
                <Typography className={classes.summaryValue}>
                  {parseDateMDY(customerLoanData?.loanExpiresOn)}
                </Typography>
              </Box>
              <Box className={classes.summaryRow}>
                <Typography className={classes.summaryLabel}>
                  Loan Amount
                </Typography>
                <Typography className={classes.summaryValue}>
                  {formatAmount(customerLoanData?.loanAmount)}
                </Typography>
              </Box>
              <Box className={classes.summaryRow}>
                <Typography className={classes.summaryLabel}>
                  Payable Principal:
                </Typography>
                <Typography className={classes.summaryValue}>
                  {formatAmount(customerLoanData?.principalOutstanding)}
                </Typography>
              </Box>
              <Box className={classes.summaryRow}>
                <Typography className={classes.summaryLabel}>
                  Interest as on date:
                </Typography>
                <Typography className={classes.summaryValue}>
                  {formatAmount(customerLoanData?.interestAmount)}
                </Typography>
              </Box>
              <Box className={classes.summaryRow}>
                <Typography className={classes.summaryLabel}>
                  Charges Payble:
                </Typography>
                <Typography className={classes.summaryValue}>
                  {formatAmount(customerLoanData?.charges)}
                </Typography>
              </Box>
              <Box className={classes.summaryRow}>
                <Typography className={classes.summaryLabel}>
                  Total Interest in Charges Payable:
                </Typography>
                <Typography className={classes.summaryValue}>
                  {formatAmount(customerLoanData?.total)}
                </Typography>
              </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={classes.paymentCard}>
            <Typography className={classes.cardTitle}>
              Payment Mode
            </Typography>
            {provider.includes("AU_UPI") && (
              <Paper elevation={0} className={classes.paymentOption}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={activeTab === "UPI"}
                      onChange={() => setActiveTab("UPI")}
                      color="primary"
                    />
                  }
                  label="Online Payment"
                />
              </Paper>
            )}
            {provider.includes("AU_QRCODE") && (
              <Paper elevation={0} className={classes.paymentOption}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={activeTab === "QR"}
                      onChange={() => setActiveTab("QR")}
                      color="primary"
                    />
                  }
                  label="QR Payment"
                />
              </Paper>
            )}
            {activeTab === "QR" && qrData && (
              <Box className={classes.qrWrapper}>
                {qrData.qrPath ? (
                  <img
                    src={qrData.qrPath}
                    alt="QR"
                    className={classes.qrImage}
                  />
                ) : (
                  <QRCodeSVG value={qrData.url} size={220} />
                )}
                <Typography
                  style={{
                    marginTop: 15,
                  }}
                >
                  Scan using any UPI App
                </Typography>
              </Box>
            )}
            <Box className={classes.amountBox}>
              <Typography
                style={{
                  color: "#666",
                }}
              >
                You are paying
              </Typography>

              <Typography className={classes.payAmount}>
                ₹ {amount || 0}
              </Typography>
            </Box>
            <Button
              fullWidth
              variant="contained"
              className={classes.proceedButton}
              onClick={() => {
                if (activeTab === "UPI") {
                  initiatePayment("AU_UPI");
                }

                if (activeTab === "QR") {
                  initiatePayment("AU_QRCODE");
                }
              }}
              disabled={Number(amount) <= 0}
            >
              Proceed To Pay
            </Button>
            <Typography className={classes.footerText}>
              🔒 Secure payment protected with bank-grade security
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default PayNow;
